import { useEffect, useState } from 'react';
import { ICommentsAndObservations } from 'types/global';
import { submitComment } from 'views/LogisticServices/utils/general.utils';
import { getStockOrderDetail } from 'services/stockOrders';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import CheckOrAddCommentsButton from 'views/orders/Components/CheckOrAddCommentsButton/CheckOrAddCommentsButton';
import CheckOrAddCommentsModal from 'views/orders/Components/CheckOrAddCommentsModal/CheckOrAddCommentsModal';

interface ICommentsModalTriggerProps {
  orderId: number;
  uuid: string;
  stockOrderComments: ICommentsAndObservations[];
}

const CommentsModalTrigger = ({ orderId, uuid, stockOrderComments }: ICommentsModalTriggerProps) => {
  const [showCommentsModal, setShowCommentsModal] = useState<boolean>(false);
  const [loadingComments, setLoadingComments] = useState<boolean>(false);
  const [dataComments, setDataComments] = useState<ICommentsAndObservations[]>();


  const handleShowCommentsModal = () => setShowCommentsModal(!showCommentsModal);

  const handleCommentsSubmission = async (comment: ICommentsAndObservations) => {
    if (!orderId) return;
    setLoadingComments(true);
    try {
      await submitComment({
        stockOrderId: orderId,
        allowNewCommentsSubmission: !loadingComments,
        handleLoading: setLoadingComments,
        comments: comment.comments,
        mentions: comment.mentions || [],
        commentImage: comment?.commentImage
      });
      const response = await getStockOrderDetail(uuid);
      setDataComments(response?.stockOrderComments || []);
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoadingComments(false);
    }
  };

  useEffect(() => {
    setDataComments(stockOrderComments || []);
  }, [stockOrderComments]);

  return (
    <div className='checkOrAddComentsButton'>
      <CheckOrAddCommentsButton openModal={handleShowCommentsModal} />
      {showCommentsModal && (
        <CheckOrAddCommentsModal
          closeModal={handleShowCommentsModal}
          orderComments={dataComments}
          handleSubmitComments={handleCommentsSubmission}
          loading={loadingComments}
        />
      )}
    </div>
  );
};

export default CommentsModalTrigger;
